<template>
  <div>
    <div id="floatingButtonbar" class="fixed-top-right q-ma-xl" style="z-index: 10">
      <q-btn @click="exportPdf" color="primary" rounded>Export as PDF</q-btn>
    </div>
    <div id="fullPlanContainer" class="row" v-if="fullPlan && $route.params.id == fullPlan.id">
      <div
        class="col-12 q-pa-xl"
        :style="`background: ${cssVars['--outcome-primary']}`"
      >
        <b class="subTitle text-white">
          What
          <span :style="`color: ${cssVars['--outcome-secondary']}`">
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>

          <br />
          is doing for their
          <span :style="`color: ${cssVars['--outcome-secondary']}`">
            {{ fullPlan.outcome.label }}
          </span>
        </b>
      </div>
      <div
        class="col-12 q-pa-xl"
        :style="`background: ${cssVars['--outcome-secondary']}`"
      >
        <div class="row items-center q-col-gutter-lg">
          <div class="col-auto">
            <q-img-rasterized
              class="q-mb-sm q-mx-auto"
              style="width: 80px; height: 80px"
              :url="getWhiteOutcomeImage(fullPlan.outcome)"
            >
            </q-img-rasterized>
          </div>
          <div class="col text-white">
            <h1>
              {{ fullPlan.outcome.label }} <br />
              Reduction Plan
            </h1>
          </div>
        </div>
        <div class="row text-white q-col-gutter-lg">
          <div class="col-4">
            <h4>
              {{
                outcomeDescriptions()[fullPlan.outcome.name].Explanation.title
              }}
            </h4>
            <div
              v-html="
                outcomeDescriptions()[fullPlan.outcome.name].Explanation.html
              "
            ></div>
          </div>
          <div class="col-4">
            <h4>
              {{ outcomeDescriptions()[fullPlan.outcome.name].Goal.title }}
            </h4>
            <div
              v-html="outcomeDescriptions()[fullPlan.outcome.name].Goal.html"
            ></div>
          </div>
          <div class="col-4">
            <h4>
              {{ outcomeDescriptions()[fullPlan.outcome.name].Examples.title }}
            </h4>
            <div
              v-html="
                outcomeDescriptions()[fullPlan.outcome.name].Examples.html
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="col-12 q-pa-xl">
        <h2
          class="q-ma-none"
          :style="`color: ${cssVars['--outcome-secondary']}`"
        >
          Where we are today
        </h2>
        <h3
          class="q-ma-none"
          :style="`color: ${cssVars['--outcome-secondary']}`"
        >
          Here's a snapshot.
        </h3>
      </div>
      <div
        v-if="fullPlan.dataSummary && fullPlan.dataSummary.data"
        class="col-12 q-pa-xl"
        :style="`background: ${cssVars['--outcome-primary']}`"
      >
        <h4 class="text-white">Our Data</h4>
        <div class="row">
          <div class="col-auto text-white generalText">
            <div>
              <h4
                class="q-ma-none"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              ></h4>

              <span class="extraBoldHeaderText">In</span>
              <span
                class="extraBoldHeaderText"
                :style="`color: ${cssVars['--outcome-secondary']}`"
                >{{ fullPlan.dataSummary.data.baselineYear }}</span
              >
              <br />
              <span
                class="text-bold"
                :style="`color: ${cssVars['--outcome-secondary']}`"
                >{{
                  currentUserData.sustainabilityBusiness_name
                    ? currentUserData.sustainabilityBusiness_name
                    : "Test Business"
                }}</span
              >
              <br />
              Total {{ fullPlan.outcome.label }} <br />
              <b>were</b> <br />
              <span
                class="extraBoldHeaderText"
                :style="`color: ${cssVars['--outcome-secondary']}`"
                >{{
                  fullPlan.dataSummary.data.baseLineData | numberFormat
                }}</span
              >
              <span class="boldUnitText">{{
                fullPlan.dataSummary.data.baseLineUnit
              }}</span>

              <!-- <h4 class="q-ma-none text-white">for</h4> -->
            </div>
          </div>
          <div class="col" style="position: relative">
            <q-card
              class="bg-white full-width q-pa-lg generalText"
              flat
              style="position: absolute; right: -27px"
            >
              <span
                class="extraBoldHeaderText"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              >
                Our Target
              </span>
              <br />

              <span :style="`color: ${cssVars['--outcome-primary']}`">
                Is to reduce that to
              </span>
              <br />
              <span
                class="extraBoldHeaderText"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              >
                {{ fullPlan.dataSummary.data.targetData | numberFormat }}</span
              >
              <span
                class="boldUnitText"
                :style="`color: ${cssVars['--outcome-primary']}`"
                >{{ fullPlan.dataSummary.data.baseLineUnit }}</span
              >
              <br />
              <span :style="`color: ${cssVars['--outcome-primary']}`">
                (Reduce {{ fullPlan.dataSummary.data.reducePercent }}%
                <b>by the end of {{ fullPlan.dataSummary.data.duebyYear }}</b
                >)
              </span>
            </q-card>
          </div>
        </div>
      </div>
      <div
        class="col-12 q-pa-xl"
        :style="`background: ${cssVars['--outcome-secondary']}`"
      >
        <div class="row items-center">
          <div class="col">
            <h4 class="text-white">Our Stories</h4>
          </div>
          <div class="col-auto">
            <q-img-rasterized
              class="q-mb-sm q-mx-auto"
              style="width: 80px; height: 80px"
              :url="getWhiteOutcomeImage(fullPlan.outcome)"
            >
            </q-img-rasterized>
          </div>
        </div>

        <div class="row q-col-gutter-md">
          <div
            class="col-auto"
            v-for="(story, index) in fullPlan.stories"
            :Key="`story_${index}`"
          >
            <storyCard :largeVersion="true" :data="story" />
          </div>
        </div>
      </div>
      <div
        class="col-12 q-pa-xl"
        v-if="
          fullPlan.scaleSummary &&
          fullPlan.scaleSummary[0] &&
          fullPlan.scaleSummary[0].possible
        "
        :style="`background: ${cssVars['--outcome-primary']}; height: 370px`"
      >
        <h4 class="text-white">Our Scale Assessment</h4>
        <div class="row">
          <div class="col-auto">
            <div>
              <h4
                class="q-ma-none"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              >
                {{
                  currentUserData.sustainabilityBusiness_name
                    ? currentUserData.sustainabilityBusiness_name
                    : "Test Business"
                }}
              </h4>
              <h5 class="q-ma-none text-white">
                Our Scale Assessment for <br />
                {{ fullPlan.outcome.label }} <br />
              </h5>
              <div
                class="row items-center"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              >
                <div class="col-6">
                  <h5 class="q-ma-none text-white">
                    <b>was</b>
                  </h5>
                </div>
                <div class="col-auto">
                  <h5 class="q-ma-none">
                    <b>{{ fullPlan.scaleSummary[0].score }}</b>
                  </h5>
                </div>
                <div class="col-auto q-px-sm">
                  <span style="font-size: 10px; line-height: 12px">
                    out of a <br />
                    best score of
                  </span>
                </div>
                <div class="col-auto">
                  <h5 class="q-ma-none">
                    <b>{{ fullPlan.scaleSummary[0].possible * 5 }}</b>
                  </h5>
                </div>
              </div>
              <!-- <h4 class="q-ma-none text-white">for</h4> -->
            </div>
          </div>
          <!-- <div class="col" style="position: relative">
            <q-card
              class="bg-white full-width q-pa-lg"
              flat
              style="position: absolute; right: -27px"
            >
              <h1
                class="q-ma-none"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              >
                Our Target
              </h1>
              <h5
                class="q-ma-none"
                :style="`color: ${cssVars['--outcome-primary']}`"
              >
                Is to increase to a score of
              </h5>
              <h1
                class="q-ma-none"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              >
                %
              </h1>
              <h4
                class="q-ma-none"
                :style="`color: ${cssVars['--outcome-secondary']}`"
              >
                (By the end of xxxx)
              </h4>
            </q-card>
          </div> -->
        </div>
      </div>
      <div class="col-12 q-pa-xl">
        <h3
          class="q-ma-none"
          :style="`color: ${cssVars['--outcome-secondary']}`"
        >
          We've set Goals for our {{ fullPlan.outcome.label }} Plan
        </h3>
        <i :style="`color: ${cssVars['--outcome-secondary']}`">
          In order to reach our target
        </i>
        <div class="row q-my-md q-gutter-sm">
          <div
            class="auto"
            v-for="(goal, index) in fullPlan.goalsWithSolutions.filter(
              (g) => g.sources_id
            )"
            :key="`goalCards_${index}`"
          >
            <q-card
              @click="scrollToTarget(`${goal.name}`)"
              flat
              class="q-pa-sm text-bold"
              :style="`background: ${cssVars['--outcome-primary']}; color: ${cssVars['--outcome-secondary']}`"
            >
              {{ goal.name }}
            </q-card>
          </div>
        </div>
        <h4
          class="q-my-none q-py-lg"
          :style="`color: ${cssVars['--outcome-secondary']}`"
        >
          Let's take a look.
        </h4>
      </div>
      <div
        class="col-12 q-pa-xl"
        :style="`background: ${
          index % 2 == 0
            ? cssVars['--outcome-secondary']
            : cssVars['--outcome-primary']
        }`"
        v-for="(goal, index) in fullPlan.goalsWithSolutions.filter(
          (g) => g.sources_id
        )"
        :key="`goalsSectionsData_${index}`"
      >
        <div class="row">
          <div class="col-12">
            <h4 class="q-my-none" :id="goal.name" :style="`color: white`">
              {{ goal.name }}
            </h4>
          </div>
          <div class="col-auto">
            <div class="row">
              <div class="col-12">
                <h5
                  class="q-my-sm"
                  :style="`color: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  Where we are
                </h5>
              </div>
              <div class="col-12">
                <q-card style="width: 320px" flat>
                  <q-card-section class="q-pa-none">
                    <q-img-rasterized
                      :url="goal.imageUrl"
                      style="width: 320px; height: 232px"
                    ></q-img-rasterized>
                  </q-card-section>
                  <q-card-section>
                    <div class="row">
                      <div class="col-12">
                        <h6 class="q-my-none text-accent">
                          Our total {{ goal.name }} for
                          {{ goal.baselineDate | momentFormatYear }} was
                        </h6>
                      </div>
                      <div class="col-12">
                        <h3
                          class="q-my-none"
                          :style="`color: ${cssVars['--outcome-primary']}`"
                        >
                          {{ goal.baselineData | numberFormat }} {{ goal.unit }}
                        </h3>
                      </div>
                      <div class="col-12 text-accent">
                        <h6 class="q-my-none">&</h6>
                      </div>
                      <div class="col-12 text-accent">
                        <h6 class="q-my-none">
                          Our {{ fullPlan.outcome.label }} for
                          {{ goal.baselineDate | momentFormatYear }}
                        </h6>
                      </div>
                      <div class="col-12">
                        <h3
                          class="q-my-none"
                          :style="`color: ${cssVars['--outcome-primary']}`"
                        >
                          {{
                            goal.customFactorData
                              ? factorCalculation(goal.customFactorData, goal)
                              : (goal.baselineData * goal.emissionsFactor)
                                | numberFormat
                          }}
                          {{ goal.factorUnit }}
                        </h3>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="col-12">
                <h5
                  class="q-my-sm"
                  :style="`color: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  Where we want to be.
                </h5>
              </div>
              <div class="col-12">
                <q-card
                  class="bg-white q-pa-lg"
                  flat
                  :style="`color: ${cssVars['--outcome-primary']}`"
                >
                  <h5 class="q-my-xs">
                    We want to
                    <b :style="`color: ${cssVars['--outcome-secondary']}`">{{
                      goal.action
                    }}</b>
                    our
                    <b :style="`color: ${cssVars['--outcome-secondary']}`">{{
                      goal.name
                    }}</b>
                    by
                    <b :style="`color: ${cssVars['--outcome-secondary']}`"
                      >{{
                        (goal.baselineData * (goal.reductionPercentage / 100))
                          | numberFormat
                      }}
                      {{ goal.unit }}</b
                    >
                  </h5>
                  <h5 class="q-my-xs">
                    ({{ goal.action }} {{ goal.reductionPercentage }}% by
                    {{ $moment(goal.due_at).format("YYYY") }})
                  </h5>
                </q-card>
              </div>
              <div class="col-12" v-if="goal.solutions.length > 0">
                <h5
                  class="q-my-sm"
                  :style="`color: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  How we'll get there.
                </h5>
              </div>
              <div
                v-for="(solution, sIndex) in goal.solutions"
                class="text-white col-12 q-my-xs"
                :key="`goalSolution_${sIndex}`"
              >
                <q-card
                  flat
                  class="q-pa-lg"
                  :style="`background: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  {{ solution.title }}
                </q-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 q-pa-xl"
        :style="`background: ${
          index % 2 == goalWithSourcesLength % 2
            ? cssVars['--outcome-secondary']
            : cssVars['--outcome-primary']
        }`"
        v-for="(goal, index) in fullPlan.goalsWithSolutions.filter(
          (g) => !g.sources_id
        )"
        :key="`goalsSectionsData2_${index}`"
      >
        <div class="row">
          <div class="col-12">
            <h4 class="q-my-none" :id="goal.name" :style="`color: white`">
              {{ goal.name }}
            </h4>
          </div>
          <div class="col-auto">
            <div class="row">
              <div class="col-12">
                <h5
                  class="q-my-sm"
                  :style="`color: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  Our Focus
                </h5>
              </div>
              <div class="col-12">
                <q-card style="width: 320px" flat>
                  <q-card-section class="q-pa-none">
                    <q-img-rasterized
                      v-if="!goal.basicGoals_id"
                      :url="goal.customImgUrl ? goal.customImgUrl : fullPlan.outcome.imageUrl"
                      style="width: 320px; height: 232px"
                    ></q-img-rasterized>
                    <q-img-rasterized
                      v-else
                      :url="goal.basicGoalImageUrl"
                      style="width: 320px; height: 232px"
                    ></q-img-rasterized>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="col-12" v-if="goal.basicGoals_id">
                <h5
                  class="q-my-sm"
                  :style="`color: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  What we want to do
                </h5>
              </div>
              <div class="col-12" v-if="goal.basicGoals_id">
                <q-card
                  class="bg-white q-pa-lg"
                  flat
                  :style="`color: ${cssVars['--outcome-primary']}`"
                >
                  <h5 class="q-my-xs">
                    {{ goal.basicGoalAction }}
                  </h5>
                </q-card>
              </div>
              <div class="col-12" v-if="goal.solutions.length > 0">
                <h5
                  class="q-my-sm"
                  :style="`color: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  How we'll get there.
                </h5>
              </div>
              <div
                v-for="(solution, sIndex) in goal.solutions"
                class="text-white col-12 q-my-xs"
                :key="`goalSolution_${sIndex}`"
              >
                <q-card
                  flat
                  class="q-pa-lg"
                  :style="`background: ${
                    index % 2 == 0
                      ? cssVars['--outcome-primary']
                      : cssVars['--outcome-secondary']
                  }`"
                >
                  {{ solution.title }}
                </q-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 q-pa-xl" v-if="fullPlan.extraSolutions.length > 0">
        <h3
          class="q-ma-none"
          :style="`color: ${cssVars['--outcome-secondary']}`"
        >
          Extra solutions we are going to explore
        </h3>
        <div class="row q-col-gutter-sm q-mt-xl">
          <div
            v-for="(solution, index) in fullPlan.extraSolutions"
            :key="`extraSolution_${index}`"
            class="col-6"
          >
            <q-card
              flat
              class="q-pa-lg text-white"
              :style="`background: ${cssVars['--outcome-primary']}`"
            >
              {{ solution.title }}
            </q-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCSSVars } from "@/functions/cssVars";
import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
import { outcomeDescriptions } from "@/functions/outcomeDescriptions";
import storyCard from "@/components/storyCards/storyCard.vue";
import { scroll } from "quasar";
import html2pdf from "html2pdf.js";
import QImgRasterized from "@/components/images/q-img-rasterized.vue";

const { getScrollTarget, setScrollPosition } = scroll;

export default {
  components: {QImgRasterized, storyCard },
  async mounted() {
    this.$store.dispatch("fullPlan/loadPlan", this.$route.params.id);
  },
  data: () => ({}),
  watch: {},
  computed: {
    ...mapGetters({
      fullPlan: "fullPlan/plan",
      currentUserData: "auth/currentUserData",
      businessExtra: "businessExtra/data",
      businessTargets: "businessTargets/list",
    }),
    cssVars() {
      let outcome = this.fullPlan.outcome;
      return getCSSVars(outcome);
    },

    goalWithSourcesLength() {
      return this.fullPlan.goalsWithSolutions.filter((g) => g.sources_id)
        .length;
    },
  },
  methods: {
    getCSSVars: getCSSVars,
    getWhiteOutcomeImage: getWhiteOutcomeImage,
    getOutcomeImage: getOutcomeImage,
    outcomeDescriptions: outcomeDescriptions,
    returnOutcomeImage(outcome) {
      return this.getOutcomeImage(outcome);
    },
    scrollToTarget(id) {
      let el = document.getElementById(id);
      const target = getScrollTarget(el);
      const offset = el.offsetTop - 20;
      setScrollPosition(target, offset);
      // setVerticalScrollPosition (scrollTargetElement, offset[, duration])
    },
    factorCalculation(data, goal) {
      if (goal.factorMultiplier) {
        return data * goal.factorMultiplier;
      }
      return data;
    },
    exportPdf() {
      let suggestedFileName = (this.fullPlan.outcome.label + ' plan').toLowerCase().replaceAll(/\s+/g, '-');
      const options = {
        margin: 0,
        filename: suggestedFileName + '.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, logging: true, dpi: 196, letterRendering: true },
        jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait' },
      };

      // Choose the element that our invoice is rendered in.
      const element = document.getElementById('fullPlanContainer');
      html2pdf().set(options).from(element).save();
    },
  },
};
</script>

<style lang="scss" scoped>
.subTitle {
  font-size: 1.1rem;
}

h1 {
  font-size: 3rem;
  font-weight: 700;
  line-height: 3.2rem;
}

h2 {
  font-size: 3rem;
  font-weight: 700;
  line-height: 3.2rem;
}

h3 {
  font-size: 2rem;
  font-weight: 700;
  line-height: 2.2rem;
}

h4 {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.7rem;
}

h5 {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.7rem;
}
h6 {
  font-size: 1rem;
  font-weight: 900;
  line-height: 1.3rem;
}

.extraBoldHeaderText {
  font-size: 3rem;
  font-weight: 900;
}

.boldUnitText {
  font-size: 1.5rem;
  font-weight: 900;
}

.generalText {
  font-size: 1.5rem;
}
</style>
